export const showModal = {
  data() {
    return {
      isModalVisible: false,
    };
  },
  methods: {
    onModalClose() {
        this.isModalVisible = false;
    },

    onModalCancel() {
      this.isModalVisible = false;
    },

    onShowModalBtnClick(){
      this.isModalVisible = true;
    },
  }
}


// WEBPACK FOOTER //
// ./src/common/mixins/showModal.js